<template>
  <div class="login-view pa-4">
    <local-login-form
      :loading="isSendingInfo"
      @submit="(fields) => submitUserCredentials(fields)"
    />
  </div>
</template>

<script>
import store from '@/services/store';
import { signIn } from '@/services/auth';

import api from '../utils/guest-api';
import { getLoginFailureOptions } from '../utils/error-utils';

import LocalLoginForm from '../components/LocalLoginForm.vue';

export default {
  name: 'LoginView',

  components: {
    LocalLoginForm,
  },

  data: () => ({
    isSendingInfo: false,
  }),

  methods: {
    async submitUserCredentials(userInfo) {
      this.isSendingInfo = true;

      try {
        const { data } = await api.auth.signIn(userInfo);

        signIn(data.token);
      } catch (error) {
        store.dispatch('alert/showAlert', getLoginFailureOptions(error));
      } finally {
        this.isSendingInfo = false;
      }
    },
  },
};
</script>
